/**------------------------------------------------------
 * Trademark Date Types
 */
export enum EnumTmDateType {
	ApplicationDate 	= 'application_date',
	RegistrationDate 	= 'registration_date'
}
